import { Component, OnInit, ViewChild, Input } from "@angular/core"; import { Location } from "@angular/common";
import { Table } from 'primeng/table';
import { BreadcrumbService } from '../../app.breadcrumb.service';

import { RequisitionService } from '../../services/requisition-service';
import { RequisitionMin } from '../../entites/requisition-min';
import { MenuItem } from 'primeng/api/menuitem';
import { MessageService, LazyLoadEvent, ConfirmationService } from 'primeng/api';
import {ToastModule} from 'primeng/toast';

import {DialogService} from 'primeng/dynamicdialog';
import { EnvoiRequisitionComponent } from '../../controles/envoi-requisition.component';
import { Router, ActivatedRoute } from '@angular/router';
import { ListeAchatService } from 'src/app/services/liste-achat-service';
import { CategorieMin, CategorieEntite } from 'src/app/entites/categorie';
import { CategorieService } from 'src/app/services/categorie-service';
import { BaseComponent } from 'src/app/base/base-component';
import { DonneesBaseService } from 'src/app/services/donnees-base-service';
import { ProfilService } from 'src/app/services/profil-service';
import { AppMainComponent } from 'src/app/app.main.component';

@Component({
    templateUrl: './categories.component.html',
    styleUrls: ['./categories.component.scss'],
    styles: [`
        @media screen and (max-width: 960px) {
            :host ::ng-deep .p-datatable.p-datatable-customers.rowexpand-table .p-datatable-tbody > tr > td:nth-child(6) {
                display: flex;
            }
        }

    `],
    providers: [MessageService, ConfirmationService, DialogService]
})
export class CategoriesComponent extends BaseComponent implements OnInit {

    categories: CategorieMin[];
    selectionCategorie: CategorieMin;

    menuContextuel: MenuItem[];

    loaded:boolean = false;

    @ViewChild('dt') table: Table;

    constructor(
        sdb: DonneesBaseService,
        profilService: ProfilService,
        route: ActivatedRoute, 
		appMain: AppMainComponent, location: Location, 
        private breadcrumbService: BreadcrumbService,
        private categorieService: CategorieService,
        private messageService: MessageService,
        private confirmationService: ConfirmationService,
        public dialogService: DialogService,
        public routerService: Router) {
            super(sdb, profilService, route, routerService, appMain);
        this.breadcrumbService.setItems([
            { label: 'Admin', routerLink: '/admin' },
            { label: 'Catégories' }
        ]);
    }

    ngOnInit() {

        this.verifierAccesPage('admin_categories');

           this.categorieService.ObtenirListe().then(x => {
               this.categories = x.valeur;

               this.CompleterChargement();
           });

        this.menuContextuel = [
            { label: 'Ouvrir', icon: 'pi pi-fw pi-search', command: () => this.OuvrirDetail(this.selectionCategorie.categorieId) },
            {separator: true},
            { label: 'Archiver', icon: 'pi pi-fw pi-times'}
        ];

       
    }

    OuvrirDetail(categorieId: number) {
        this.routerService.navigateByUrl(`admin/categorie/${categorieId}`)
    }
    

}
